import { IApp } from "@API/Apps/types";
import { RootState } from "@Store";

export const selectAppsList = (state: RootState): IApp[] => state.apps.list.list;

export const selectAppsListLoading = (state: RootState): boolean =>
  state.apps.list.isLoading;

export const selectShowCreateAppModal = (state: RootState): boolean =>
  state.apps.createModal.isVisible;

export const selectCreateAppModalLoading = (state: RootState): boolean =>
  state.apps.createModal.isLoading;

export const selectAppPolicyData = (state: RootState) => state.apps.policy.data;

export const selectAppPolicyLoading = (state: RootState): boolean =>
  state.apps.policy.isLoading;
